/* Mobile Screen 576px */
export const mobile = "576px";
/* Tablet Screen 768px */
export const tablet = "768px";
/* Laptop Screen 992px */
export const laptop = "992px";
/* Desktop Screen 1200px */
export const desktop = "1200px";
/* Large-Desktop Screen 1600px */
export const largeDesktop = "1600px";
export const cmGreen100 = "#bfffba";
export const mintelGreen200 = "#9acd32";
export const mintelSand50 = "#fffcf1";
export const cmDeepPurple50 = "#f1e9ff";
export const cmPink400 = "#c31e8a";
export const mintelGray50 = "#f8f8f8";
export const cmBlue100 = "#90ffff";
export const cmGreen200 = "#05ff7e";
export const mintelGreen300 = "#7fa829";
export const cmPink500 = "#830669";
export const cmBlue200 = "#00e0ff";
export const cmGreen300 = "#00cc8f";
export const mintelGreen400 = "#458415";
export const mintelMint50 = "#def7e6";
export const cmPink600 = "#5c1440";
export const mintelBlue100 = "#c1dcf8";
export const cmBlue300 = "#008eff";
export const cmGreen400 = "#00857a";
export const mintelGreen500 = "#325d10";
export const cmPurple100 = "#ffc4ff";
export const mintelBlue200 = "#89c3fe";
export const cmBlue400 = "#0050dc";
export const cmGreen500 = "#005866";
export const mintelPurple100 = "#f3d9ee";
export const mintelGreen600 = "#273300";
export const cmPurple200 = "#ff70ff";
export const mintelBlue300 = "#519de9";
export const mintelPurple200 = "#e1a2d5";
export const cmPurple300 = "#d500f9";
export const mintelBlue400 = "#026fd9";
export const cmBlue500 = "#00138c";
export const cmGreen600 = "#002133";
export const cmPurple400 = "#9100b7";
export const mintelBlue500 = "#0052a5";
export const cmBlue600 = "#000b54";
export const mintelPurple300 = "#cf6abc";
export const cmPurple500 = "#550075";
export const mintelBlue600 = "#013161";
export const mintelPurple400 = "#ac2f96";
export const mintelGold100 = "#ffedbf";
export const cmPurple600 = "#330046";
export const mintelPurple50 = "#faf0f8";
export const mintelPurple500 = "#681c5a";
export const mintelGold200 = "#ffd97a";
export const cmPlum = "#661d51";
export const cmPurple50 = "#ffe3fc";
export const mintelBlack = "#000";
export const mintelPurple600 = "#380e38";
export const mintelGold300 = "#ffb400";
export const mintelYellow = "#fedb00";
export const cmLime = "#defab6";
export const mintelBlue50 = "#edf5fd";
export const mintelMint100 = "#beefce";
export const cmBlack = "#000";
export const mintelGray100 = "#e8e8e8";
export const cmBlue50 = "#c8ffff";
export const mintelMint200 = "#99e6b3";
export const mintelGold400 = "#c88c00";
export const mintelGray200 = "#ccc";
export const cmGreen50 = "#e6ffde";
export const cmDeepPurple100 = "#dccaff";
export const mintelSand100 = "#fff8dc";
export const mintelMint300 = "#7ebd93";
export const mintelGold500 = "#7d5a00";
export const mintelGreen50 = "#e5f2cb";
export const mintelGray300 = "#939393";
export const cmDeepPurple200 = "#b871ff";
export const mintelSand200 = "#e8e2c8";
export const mintelMint400 = "#547e62";
export const mintelRed100 = "#ffb9b9";
export const mintelGray400 = "#666";
export const mintelSeafoam = "#11a988";
export const cmDeepPurple300 = "#8e3eff";
export const mintelMint500 = "#385442";
export const mintelRed200 = "#ff7474";
export const mintelGray500 = "#2b2b2b";
export const cmSeafoam = "#00ffe1";
export const cmDeepPurple400 = "#550fcc";
export const mintelMint600 = "#203226";
export const cmNeon50 = "#faffc2";
export const mintelRed300 = "#f83943";
export const cmPink50 = "#fce3ec";
export const mintelLavender100 = "#dedeea";
export const cmDeepPurple500 = "#3b0b89";
export const mintelRed400 = "#cb0b16";
export const mintelLavender200 = "#aeaeca";
export const cmDeepPurple600 = "#350066";
export const mintelRed500 = "#87080f";
export const mintelLavender300 = "#7d7eab";
export const mintelRoyal = "#5e358b";
export const mintelAqua = "#afe9d8";
export const mintelRed600 = "#461212";
export const mintelLavender400 = "#4d4e8c";
export const mintelWhite = "#fff";
export const mintelLavender500 = "#353957";
export const cmWhite = "#fff";
export const mintelLavender600 = "#1c1d33";
export const mintelOrange100 = "#ffcc98";
export const mintelOrange50 = "#ffebd6";
export const mintelOrange200 = "#ffa343";
export const mintelOrange300 = "#e66723";
export const mintelOrange400 = "#bf360c";
export const mintelOrange500 = "#7a2308";
export const mintelOrange600 = "#461405";
export const cmNeon100 = "#f1ff82";
export const mintelLavender50 = "#eeeef4";
export const cmPink100 = "#f8bbd0";
export const cmPink200 = "#ff66ac";
export const cmNeon200 = "#cf0";
export const mintelRed50 = "#ffe3e3";
export const mintelGreen100 = "#bedf7c";
export const cmPink300 = "#ff0076";
export const cmNeon300 = "#aadc00";
/* Primary font for Mintel branding - DEPRECATED, use Neue Einstellung */
export const latoFont = "NeueEinstellung, Arial";
/* Primary font across all products */
export const neueEinstellungFont = "NeueEinstellung, Arial";
export const arialFont = "Arial";
/* Data font */
export const dinproFont = "DINPro, Arial";
export const dataCellWeight = "normal";
export const dataAnnotationHeight = "12px";
export const breadcrumbHeight = "16px";
export const ban2Height = "30px";
export const ban1Height = "30px";
export const bodyHeight = "20px";
export const dataHeaderHeight = "14px";
export const buttonWeight = "bold";
export const linkSize = "11px";
export const body3Weight = "normal";
export const legalSize = "10px";
export const body2Weight = "normal";
export const dataPaginationWeight = "normal";
export const dataCellSize = "14px";
export const h6Weight = "bold";
export const h5Weight = "bold";
export const h4Weight = "bold";
export const h3Weight = "bold";
export const linkHeight = "16px";
export const legalHeight = "16px";
export const h2Weight = "bold";
export const buttonSize = "12px";
export const h1Weight = "bold";
export const body3Size = "11px";
export const dataCellHeight = "14px";
export const body2Size = "12px";
export const dataPaginationSize = "12px";
export const h6Size = "12px";
export const h5Size = "14px";
export const dataAnnotationWeight = "normal";
export const ban2Weight = "normal";
export const breadcrumbWeight = "normal";
export const buttonHeight = "normal";
export const h4Size = "16px";
export const dataHeaderWeight = "bold";
export const body3Height = "16px";
export const h3Size = "18px";
export const ban1Weight = "normal";
export const bodyWeight = "normal";
export const body2Height = "20px";
export const h2Size = "22px";
export const dataPaginationHeight = "14px";
export const h1Size = "30px";
export const h6Height = "20px";
export const h5Height = "20px";
export const h4Height = "20px";
export const h3Height = "24px";
export const dataAnnotationSize = "12px";
export const h2Height = "30px";
export const ban2Size = "24px";
export const h1Height = "normal;";
export const linkWeight = "normal";
export const breadcrumbSize = "11px";
export const ban1Size = "22px";
export const bodySize = "14px";
export const dataHeaderSize = "12px";
export const legalWeight = "normal";
/* (XXS) Tiny spacing */
export const spacing100 = "2px";
/* (XS) Extra Small spacing */
export const spacing200 = "4px";
/* (S) Small spacing */
export const spacing300 = "8px";
/* (S+) spacing */
export const spacing350 = "12px";
/* (M) Medium spacing */
export const spacing400 = "16px";
/* (M+) Medium spacing */
export const spacing450 = "24px";
/* (L) Large spacing */
export const spacing500 = "32px";
/* (XL) Extra large spacing */
export const spacing600 = "64px";
export const h5SizeResponsive = "0.875rem";
export const h6SizeResponsive = "0.75rem";
export const dataPaginationSizeResponsive = "0.75rem";
export const body2SizeResponsive = "0.75rem";
export const dataCellHeightResponsive = "0.875rem";
export const body3SizeResponsive = "0.6875rem";
export const buttonSizeResponsive = "0.75rem";
export const legalHeightResponsive = "1rem";
export const linkHeightResponsive = "16px";
export const dataCellSizeResponsive = "0.875rem";
export const legalSizeResponsive = "0.625rem";
export const linkSizeResponsive = "0.6875rem";
export const dataHeaderHeightResponsive = "0.875rem";
export const bodyHeightResponsive = "1.25rem";
export const ban1HeightResponsive = "30px";
export const ban2HeightResponsive = "1.875rem";
export const breadcrumbHeightResponsive = "1rem";
export const dataAnnotationHeightResponsive = "0.75rem";
export const bodySizeResponsive = "0.875rem";
export const ban1SizeResponsive = "1.375rem";
export const dataHeaderSizeResponsive = "0.75rem";
export const breadcrumbSizeResponsive = "0.6875rem";
export const h1HeightResponsive = "normal;";
export const ban2SizeResponsive = "1.5rem";
export const dataAnnotationSizeResponsive = "0.75rem";
export const h2HeightResponsive = "1.875rem";
export const h3HeightResponsive = "1.5rem";
export const h4HeightResponsive = "1.25rem";
export const h5HeightResponsive = "1.25rem";
export const h6HeightResponsive = "1.25rem";
export const h1SizeResponsive = "1.875rem";
export const dataPaginationHeightResponsive = "0.875rem";
export const body2HeightResponsive = "1.25rem";
export const h2SizeResponsive = "1.375rem";
export const h3SizeResponsive = "1.125rem";
export const body3HeightResponsive = "1rem";
export const h4SizeResponsive = "1rem";
export const buttonHeightResponsive = "normal";
/* (M+) Medium spacing */
export const spacing450Responsive = "1.5rem";
/* (S+) spacing */
export const spacing350Responsive = "0.75rem";
/* (XXL) Extra Extra large spacing */
export const spacing700Responsive = "5rem";
/* (XL) Extra large spacing */
export const spacing600Responsive = "4rem";
/* (L) Large spacing */
export const spacing500Responsive = "2rem";
/* (M) Medium spacing */
export const spacing400Responsive = "1rem";
/* (S) Small spacing */
export const spacing300Responsive = "0.5rem";
/* (XS) Extra Small spacing */
export const spacing200Responsive = "0.25rem";
/* (XXS) Tiny spacing */
export const spacing100Responsive = "0.125rem";